import script from "./pointer-fx.vue?vue&type=script&setup=true&lang=ts"
export * from "./pointer-fx.vue?vue&type=script&setup=true&lang=ts"

import "./pointer-fx.vue?vue&type=style&index=0&id=05f64560&lang=css"

const __exports__ = script;

export default __exports__